import {
  GetSupplierProductByMainNo,
  GetThreeStockInfoByScanInfo,
  GetThreeStocks
} from '@/api'

export default {
  name: 'ScanMixin',
  data () {
    return {
      // 扫码框焦点
      scanInputIsfocus: false,
      // 是否扫码界面
      showCode: false,
      // 扫码次数
      count: 0,
      // 扫到的码
      code: '',
      // 上次时间
      lastTime: 0,

      tableCode: ''
    }
  },
  mounted () {
    this.tableCode = this.$route.name.replace('Edit', '') //this.$route.path.replace('/', '')

    window.addEventListener("keypress", this.init, true)
  },
  destroyed () {
    window.removeEventListener("keypress", this.init, true)
  },

  methods: {
    // 扫码相关
    init (e) {
      var currCode = e.which;
      var currTime = new Date().getTime();
      if (this.lastTime > 0) {
        if (currTime - this.lastTime <= 100) {
          // this.code += String.fromCharCode(currCode);
        } else {
          // if (currTime - this.lastTime > 1000) {
          // 超时清空
          this.clearCode();
        }
        this.code += String.fromCharCode(currCode);
      }
      // 第一次按键
      else {
        this.code = String.fromCharCode(currCode);
      }
      this.lastTime = currTime;
      // 遇到回车
      if (currCode == 13 && this.isScan && !this.scanInputIsfocus) {
        // alert(code); // 这里得到码，做下一步业务处理
        this.mainNoChange(this.code)
        // console.log("123456789")
        // 回车输入后清空
        this.clearCode();
      }
    },
    clearCode () {
      this.code = '';
      this.lastTime = 0;
    },
    mainNoChange (val) {
      // 去掉空格
      val = val.replace(/\s+/g, "").toUpperCase()
      if (!val || val == '') {
        return;
      }

      if (this.count === 0) {
        if (this.childForm.mainNo && this.childForm.traceNo) {
          let valid = this.pushChildForm(false)
          if (!valid) {
            this.code = '';
            this.childForm.no = ''
            return
          }
        }
        this.getSupplierProductByMainno(val)
      }
      else {
        if (val == this.childForm.mainNo) {
          this.$my_message('主码和追溯码不能相同', 'warning')
          return
        }
        var traceNo = val
        if (this.childForm.mainNo) {
          traceNo = val.startsWith(this.childForm.mainNo) ? val.substr(this.childForm.mainNo.length, val.length - this.childForm.mainNo.length) : val
        }
        this.getSupplierByTraceNo(traceNo)
      }
    },
    getSupplierProductByMainno (no) {
      var reg = RegExp(`^${this.childForm.mainNo}`)
      if (no == this.childForm.mainNo || (reg.exec(no) && this.childForm.mainNo && this.childForm.mainNo != '')) {
        this.count++
        this.childForm.no = ''
        return;
      }
      this.resetDetailFormData()
      GetSupplierProductByMainNo({ mainNo: no })
        .then(res => {
          if (!res.successful) {
            return
          }
          // this.childForm = this.mapper.OutStockSupplierProduct2Form(this.childForm, res.returnData)
          this.childForm = Object.assign(this.childForm, res.returnData);
          this.childForm.orgCode = sessionStorage.getItem('orgId')
          this.childForm.supplierProductId = res.returnData.id
          this.childForm.supplierProductNo = res.returnData.no
          this.childForm.number = 0
          this.childForm.price = this.childForm.purchasePrice
          this.childForm.amount = 0
          this.childForm.mainNo = this.childForm.countryNo
          this.childForm.remark = ''

          this.count++
          this.childForm.no = ''

          // GetThreeStocks({ keyWord: this.childForm.specName })
          //   .then(res => {
          //     this.childForm.stockQuantity = res.returnData.data[0].stockQuantity;
          //     this.childForm.batch = res.returnData.data[0].batch;
          //     this.childForm.validityDate = res.returnData.data[0].validityDate;
          //   })


        })
    },

    getSupplierByTraceNo (no) {
      if (this.childForm.traceNo == no && this.childForm.number > 0) {
        this.childForm.number = this.childForm.number * 1 + 1
        this.childForm.amount = this.childForm.number * this.childForm.price
        this.count--
        this.childForm.no = ''
        return;
      }

      //添加行
      let arr = this.form.details.filter(item => item.mainNo == this.childForm.mainNo && item.traceNo == no)
      // this.childForm.traceNo = no

      // 添加行记录
      if (arr.length > 0) {
        // 存在则把列表的数据拿过来，并且数量加1
        this.form.details = this.form.details.map(item => {
          if (item.mainNo == this.childForm.mainNo && item.traceNo == no) {
            this.childForm.orgCode = sessionStorage.getItem('orgId')
            this.childForm.stockId = item.stockId
            this.childForm.supplierId = item.supplierId
            this.childForm.supplierName = item.supplierName
            this.childForm.packSpec = item.packSpec
            this.childForm.traceNo = item.traceNo
            this.childForm.manufactureDate = item.manufactureDate
            this.childForm.batch = item.batch
            this.childForm.validityDate = item.validityDate
            this.childForm.serialNo = item.serialNo
            this.childForm.locationId = item.locationId
            this.childForm.locationName = item.locationName
            this.childForm.stockCategory = item.stockCategory
            this.childForm.stockCategoryName = item.stockCategoryName

            this.childForm.number = item.number * 1 + 1
            this.childForm.price = item.price
            this.childForm.billingPrice = item.billingPrice
            this.childForm.amount = this.childForm.number * this.childForm.price
          }
          return item
        })

        this.count--
        this.childForm.no = ''
      } else {
        // 不存在则调用扫码解析，解析成功添加行记录
        let deptId = this.form.ownerDept

        var query = { traceNo: no, deptId: deptId, mainNo: this.childForm.mainNo }
        if (this.tableCode == 'ThreeStockTransfer') {
          query.deptId = this.form.outDeptId
          query.stockCategory = 0
        }
        GetThreeStockInfoByScanInfo(query)
          .then(res => {
            if (!res.successful) {
              this.childForm.$index = this.form.details.length + 1
              this.childForm.stockId = ''
              this.childForm.supplierId = ''
              this.childForm.supplierName = ''
              this.childForm.packSpec = ''
              this.childForm.number = 0
              this.childForm.amount = 0
              this.childForm.traceNo = ''
              this.childForm.manufactureDate = ''
              this.childForm.batch = ''
              this.childForm.validityDate = ''
              this.childForm.serialNo = ''
              this.childForm.stockCategory = ''
              this.childForm.stockCategoryName = ''
              return
            }
            this.count--
            this.childForm.no = ''
            this.childForm.$index = this.form.details.length + 1
            this.childForm.stockId = res.returnData.id
            this.childForm.supplierId = res.returnData.supplierId
            this.childForm.supplierName = res.returnData.supplierName
            this.childForm.packSpec = res.returnData.packSpec
            this.childForm.price = res.returnData.price
            this.childForm.number = 1
            this.childForm.billingPrice = res.returnData.billingPrice
            this.childForm.orgCode = sessionStorage.getItem('orgId')
            this.childForm.amount = this.childForm.price
            this.childForm.traceNo = res.returnData.traceNo
            this.childForm.manufactureDate = res.returnData.manufactureDate
            this.childForm.batch = res.returnData.batch
            this.childForm.validityDate = res.returnData.validityDate
            this.childForm.serialNo = res.returnData.serialNo
            this.childForm.stockCategory = res.returnData.stockCategory
            this.childForm.stockCategoryName = res.returnData.stockCategoryName
            this.childForm.stockQuantity = res.returnData.stockQuantity
            this.childForm.productRegistCertId = res.returnData.productRegistCertId
            this.childForm.productRegistCertNo = res.returnData.productRegistCertNo
            this.childForm.productRegistCertName = res.returnData.productRegistCertName
            this.childForm.manufacturerId = res.returnData.manufacturerId
            this.childForm.manufacturerName = res.returnData.manufacturerName

          })
      }
    },

    scanInputFocus () {
      this.$forceUpdate()
      this.scanInputIsfocus = true
    },
    scanInputBlur () {
      this.$forceUpdate()
      this.scanInputIsfocus = false
    },
  }
}
